export const STOCK_TTL_ES = 'Stock de Venta';

export interface IStockBase {
  productId: number;
  branchStoreName: string;
  branchStoreId: number;
  lot: string;
  expAt: Date;
  quantity: number;
  purchasePrice: number;
  salePrice: number;
  statusPriceId: number;
  profitMargin: number;
  withIgv: boolean;
}

export interface IStock extends IStockBase {
  id: number;
  productRegulatedCondition: string;
  productRegulatedConditionCode: string;
  tagStatusColor: string;
}
export type IStockUpdate = Partial<IStockBase>;
